
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, CheckCircle } from "lucide-react";

interface SessionStatusAlertProps {
  isValidSession: boolean;
  sessionError: string;
}

export function SessionStatusAlert({ isValidSession, sessionError }: SessionStatusAlertProps) {
  if (!isValidSession && sessionError) {
    return (
      <Alert variant="destructive" className="mb-4">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>{sessionError}</AlertDescription>
      </Alert>
    );
  }

  if (isValidSession) {
    return (
      <Alert className="mb-4">
        <CheckCircle className="h-4 w-4" />
        <AlertDescription>
          Password reset session verified. You can now set your new password.
        </AlertDescription>
      </Alert>
    );
  }

  return null;
}
